// import React, {useContext, useRef, useEffect, useState} from 'react'
// import {useParams,Link, useHistory} from 'react-router-dom'
// import DatePicker from 'react-datepicker'
// import Select from "react-select";

// import { Document, Page, Text, View, StyleSheet , PDFViewer,PDFDownloadLink,Image} from '@react-pdf/renderer';


// import FullCalendar, { formatDate } from '@fullcalendar/react'
// import dayGridPlugin from '@fullcalendar/daygrid'
// import timeGridPlugin from '@fullcalendar/timegrid'
// import interactionPlugin from '@fullcalendar/interaction'

// // import Generatereport from './Generatereport';
// import NavBar from './nav';

// import {UserContex} from '../App'

// const Expense = ()=>{

//   const history = useHistory()
//   const {state, dispatch}= useContext(UserContex)

//   const  [data, setData]= useState([])
//   const  [creditData, setCreditData]= useState([])
//   const  [TotalExpense, setTotalExpense]= useState()
  
//   const [search,setSearch] = useState("")

//   const [addCredit,setAddCredit]= useState(false)

//   const[name,setName]= useState("")
//   const[description,setDescription]= useState("")
//   const[amount,setAmount]= useState()
//   const[jrnl,setJrnl]= useState()
//   const[date,setDate]= useState(new Date)
//   const [showCalender,setShowCalender] = useState(false)

//   const fileName = 'Bill'


    


//   useEffect(  ()=>{

   
//     fetch(`/getExpenses`,{
//       headers:{
//           Authorization: "Bearer " +localStorage.getItem("jwt")
          
//       }
//   }).then(res=>res.json())
//   .then(result=>{

//       setCreditData(result.expenses)
//       setTotalExpense(result.sumExpense)
      
//   })

   





//   },[])



//   const postCredit = ()=>{

//     fetch('/addExpenses',{

//       method:"post",
//       headers:{
//         "Content-Type":"application/json",
//         Authorization: "Bearer " +localStorage.getItem("jwt")

//       },
//       body: JSON.stringify({
//         name,
//         description,
//         jrnl,
//         amount,
//       date})
      
//     }).then(res=>res.json())
//     .then(data=>{
//       if(data.error){
//         console.log("Error")
//         window.location.reload(false);

//       }

//       else{
        
//         window.location.reload(false);
    

//       }
//     })
//     .catch(err=>{
//       console.log(err)
//     })

//   }
//   const deleteExpense = (id)=>{

//     fetch(`/deleteexpense/${id}`,{
//         method: "delete",
//         headers:{
//             Authorization:"Bearer "+localStorage.getItem("jwt")
//         }
//     }).then(res=>res.json())
//     .then(result=>{
//       window.location.reload(false);

//     }).catch(err=>{
//         console.log(err)
//     })
// }


  




//   const fetchPost=(query)=>{


//     setSearch(query)

//     fetch('/search-expense',{

//       method:"post",
//       headers:{
//         Authorization: "Bearer " +localStorage.getItem("jwt"),
//         "Content-Type":"application/json"

//       },
//       body:JSON.stringify({
//         query
//       })

//     }).then(res=> res.json())
//       .then(results=>{
        
//         setCreditData(results.expense)
//         var sum =0
//         results.expense.map(expense=>{
//           sum+=expense.amount

//         })

//         setTotalExpense(sum)
//       })


//   }

  
    
//   const searchdate=(query)=>{

  
  
//     fetch('/searchdateexpense',{
  
//       method:"post",
//       headers:{
//         Authorization: "Bearer " +localStorage.getItem("jwt"),
  
//         "Content-Type":"application/json"
  
//       },
//       body:JSON.stringify({
//        date: query
//       })
  
//     }).then(res=> res.json())
//       .then(results=>{
        
//         setCreditData(results.order)

//         var sum =0
//         results.order.map(expense=>{
//           sum+=expense.amount

//         })

//         setTotalExpense(sum)
  
       
        
//       })
  
  
//   }
  
  
//   const PDFComponent = (da) => (


//     <Document>
//     <Page size="A4" style={styles.page}>
//       <View style={styles.header}>
//       <Image style={styles.logo} src="/logo.png"
//    />
  
//         <Text style={styles.address}>Green Gold Wood Works</Text>
//         <Text style={{fontSize:10, marginBottom: 3}}>Tsirang</Text>
//         <Text style={{fontSize:10,marginBottom: 3}}>TPN: GAB66324</Text>
//         <Text style={{fontSize:10,marginBottom: 3}}>Contact:77428435 / 77413093</Text>
  
//       </View>
  
//       <View style={styles.invoiceDetails}>
//         <View style={styles.itemList}>
//           <View style={styles.itemRow}>
//             <Text style={styles.label}>Name</Text>
//             <Text style={styles.label}>Description</Text>
//             <Text style={styles.label}>Amount</Text>
//             <Text style={styles.label}>Date</Text>
//           </View>
//           {creditData.map((item, index) => (
//             <View key={index} style={styles.itemRow}>
//               <Text style={styles.itemDescription}>{item.name}</Text>
//               <Text style={styles.itemDescription}>{item.description}</Text>
//               <Text style={styles.itemDescription}>{item.amount}</Text>
//               <Text style={styles.itemDescription}>{item.date.substring(0,10)}</Text>
//             </View>
//           ))}
//         </View>
       
//         <View style={styles.totalRow}>
//           <Text style={styles.totalLabel}>Total:{TotalExpense}</Text>
//           {/* <Text style={styles.totalValue}>{invoice.total}</Text> */}
//         </View>
//       </View>
//     </Page>
//   </Document>
    
//   );
  
//   const styles = StyleSheet.create({
//     page: {
//       fontFamily: 'Helvetica',
//       padding: 30,
//     },
//     header: {
//       marginBottom: 20,
//       justifyContent: 'center',
//       alignItems: 'center',
//     },
//     title: {
//       fontSize: 20,
//       fontWeight: 'bold',
//       marginBottom: 10,
//     },
//     address: {
//       fontSize: 12,
//       marginBottom: 10,
//     },
//     invoiceDetails: {
//       marginBottom: 20,
//     },
//     label: {
//       fontSize: 20,
//       fontWeight: 'bold',
//     },
//     value: {
//       fontSize: 12,
//     },
//     itemList: {
//       marginTop: 20,
//     },
//     itemRow: {
//       flexDirection: 'row',
//       justifyContent: 'space-evenly',
//       marginBottom: 8,
//       marginLeft:8
//     },
//     itemDescription: {
//       width: '20%',
//       textAlign:'center'
//     },
//     itemQuantity: {
//       width: '15%',
//       textAlign: 'left',
//     },
//     itemAmount: {
//       width: '25%',
//       textAlign: 'right',
//     },
//     totalRow: {
//       flexDirection: 'row',
//       justifyContent: 'flex-end',
//       marginTop: 10,
//     },
//     totalLabel: {
//       fontSize: 14,
//       fontWeight: 'bold',
//     },
//     totalValue: {
//       fontSize: 14,
//       marginLeft: 10,
//     },
//     logo: {
//       width: 80, 
//       height: 80, 
//       marginBottom: 10,
//       justifyContent: 'center',
//       alignItems: 'center',  },
  
  
//     horizontalLine: {
//       borderTop: 1,
//       borderColor: 'black',
//       marginVertical: 10,
//       width: '100%',
//     },
//   });
  
      

// return(

//     <div>


//  <script src="https://cdn.jsdelivr.net/gh/alpinejs/alpine@v2.x.x/dist/alpine.min.js" defer></script>

//  <div  className="flex h-screen bg-white">

//  <div className=" "></div>

//         <link rel="stylesheet" href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css" />
  






//         <div className="flex-1 flex flex-col overflow-hidden ">

            
// <NavBar/>


//             <main className="flex-1 overflow-x-hidden overflow-y-auto bg-white">
//   <div className="container mx-auto px-6 py-8">
//     <h3 className="text-gray-400 text-3xl font-medium">Expenses</h3>


// <div className="flex md:flex-row flex-col ...">


// <div class="shadow-lg rounded-xl bg-gray-200 w-full md:w-64 p-6 bg-white dark:bg-gray-500 relative overflow-hidden">

//     <div class="flex items-center my-4 text-blue-500 rounded justify-between">
//         <span class="rounded-lg p-2 bg-white">
//         <svg class="h-8 w-8 text-gray-500"  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <rect x="7" y="9" width="14" height="10" rx="2" />  <circle cx="14" cy="14" r="2" />  <path d="M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2" /></svg>        
        
        
//              </span>
//         <div class="flex flex-col w-full ml-2 items-start justify-evenly">
//             <p class="text-black text-lg">
//             Nu. {TotalExpense}
//             </p>
//             <p class="text-gray-700 text-sm">
//                 Total Expenses
//             </p>
            
//         </div>

      
//     </div>
//     <div class="mt-4">
//         <button type="button" class="py-2 px-4  bg-black hover:bg-gray-400 focus:ring-gray-400 focus:ring-offset-gray-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md "
        
//         onClick={()=>setAddCredit(true)}
//         >
//             Add Expense +
//         </button>
//     </div>
// </div>




  
// </div>
    
   
    
  
//     <br/>








//     <div className="w-full h-10 pl-3 pr-2 bg-gray-100 border-gray-50 rounded-full  outline-none  border-none flex focus:outline-none justify-between items-center relative">
//   <input type="text" name="search" id="search" placeholder="Search" 
//          className=" w-full bg-gray-100 border-none rounded-full    focus:outline-none focus:border-white active:outline-none"
//          value= {search} onChange={(e)=>fetchPost(e.target.value)}
//          />
//   <button type="submit" className="ml-1 outline-none border-none focus:border-none  active:outline-none">
//     <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
//          viewBox="0 0 24 24" className="w-6 h-6">
//       <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
//     </svg>
//   </button>
// </div>

// <br/>
    
//     <div class="flex flex-row">


  

// <div>

// <span class={`px-4 py-2 m-2 flex w-48 items-center text-base rounded-full text-blue-500   ${showCalender?"bg-blue-200":"border border-indigo-300 undefined"} cursor-pointer`}
// onClick={()=>setShowCalender(!showCalender)}
// >
// <svg class="h-8 w-8 text-blue-500"  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <rect x="4" y="5" width="16" height="16" rx="2" />  <line x1="16" y1="3" x2="16" y2="7" />  <line x1="8" y1="3" x2="8" y2="7" />  <line x1="4" y1="11" x2="20" y2="11" />  <rect x="8" y="15" width="2" height="2" /></svg>
//     Search by Date
// </span>

// </div>



// </div>



// <div class="flex space-x-4">

// {/* <MyPDF /> */}

// {/* <Generatereport/> */}





// </div>



// {/* <button type="button" class=" py-2 px-4 flex justify-center items-center  bg-green-600 hover:bg-red-700 focus:ring-red-500 focus:ring-offset-red-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "

// onClick={()=>setAddCredit(true)}
// >
// <svg class="h-8 w-8 text-white"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
//   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
// </svg>

//     Add Expenses
// </button> */}



// <br/>
// {showCalender?<>

// <div class="h-1/2 w-1/2">
//   <FullCalendar
  
//   plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//   headerToolbar={{
//     // left: 'prev,next today',
//     // center: 'title',
//     // right: 'dayGridMonth',
//   }}
//   initialView='dayGridMonth'
//   editable={true}
//   selectable={true}
//   selectMirror={true}
//   dayMaxEvents={true}
//   height={300}
//   // weekends={weekendsVisible}
//   // events={data} 
//   // select={handleDateSelect}
//   // eventContent={renderEventContent}
//   //  eventClick={handleEventClick}
//   // eventsSet={handleEvents}

//   dateClick={(info)=>{

//       searchdate(info.dateStr)

//       // console.log("INFOOO",info.dateStr)
//   }}
  
// />
// </div>

// <br/>

// </>:<></>}

// <div >
//           <PDFDownloadLink document={<PDFComponent test={"TESt sf"}/>} fileName="bill.pdf">
//       {({ blob, url, loading, error }) =>
//         loading ? 'Loading document...' : <>
//         <span class={`px-4 py-2 m-2 flex w-24 items-center text-base rounded-full text-blue-500  hover:bg-blue-200 border border-indigo-300 undefined  cursor-pointer`}
// >
// <svg class="h-8 w-8 text-blue-500"  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />  <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />  <rect x="7" y="13" width="10" height="8" rx="2" /></svg>
//     Print
// </span>
//         </>
//       }
//     </PDFDownloadLink>
            
//             </div>


// <div className="flex ">
//       <div className="grid  grid-cols-2 md:grid-cols-6 space-x-1 space-y-1">

    


//         { creditData?  creditData.map(item=>{

//             return(

  
//               <div className="   bg-white w-full flex items-center p-2 rounded-xl shadow-md border transition duration-500 transform hover:-translate-y-1 hover:scale-111 ease-in-out">
//               <div className="flex-grow p-5   ">
//               <div style={{cursor:"pointer"}} className="absolute top-1 right-1 text-red-600"
                  
//                   onClick={()=>{if(window.confirm('Are you sure you want to delete?')) deleteExpense(item._id)}}
             
//                    >
//                      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
             
//                    ></path>  
//                    </svg></div>
//                    <div className="font-semibold text-gray-700">
//                   {item.name}
                  
//                 </div>
//                 <div className="text-sm text-gray-500">
//                   Description: {item.description}
//                 </div>
//                 {item.jrnl?<div className="text-sm text-gray-500">
//                   Jrnl: {item.jrnl}
//                 </div>:<></>
                
//               }
                
              
//                 <div className="text-sm text-gray-500">
//                   Amount : {item.amount}
//                 </div>
//                 <div className="text-sm text-gray-500">
//                   Date : {item.date.substring(0,10)}
//                 </div>
            
//               </div>
//             </div>
//             )

//         }): <>Loading! </>


//         }
      
        
          
   
   
          
        
      
//       </div>
     
//     </div>
 
//     {
// addCredit? 
// (
//   <>
//     <div
//       className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
//     >
//       <div className="relative w-auto my-6  relative w-auto my-6 mx-auto ">
//         {/*content*/}
//         <div className=" border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
//           {/*header*/}
//           <div className="flex rounded-full items-start  p-5 ">
            
//             <button
//               className="p-1 ml-auto rounded-full bg-red-500 text-white text-3 "
//               onClick={() => setAddCredit(false)}
//             >
// <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>            </button>
//           </div>
//           {/*body*/}
//           <div className="relative p-6 flex-auto">
           
//           <form >



            
//         <div className=" overflow-hidden sm:rounded-md">
//           <div className="px-4 py-5 bg-white sm:p-6">
//             <div className="grid grid-cols-6 gap-6">
//               <div className="col-span-6 sm:col-span-4">
//                 <label htmlFor="first_name" className="block text-sm font-medium text-gray-700">Name</label>
                
//                 <input type="text" 
//               name="first_name"
//                id="first_name" 
//                autoComplete="given-name"
//               className="rounded-lg w-full
//               bg-white border-2 border-gray-300 placeholder-gray-400  focus:placeholder-gray-200 focus:bg-white focus:border-indigo-300  focus:outline-none" 
//               value={name}
//               onChange={(e)=>setName(e.target.value)}  
//                 />
              
//               <label htmlFor="first_name" className="block text-sm font-medium text-gray-700">Description</label>

//               <select type="text" 
//               name="first_name"
//                id="first_name" 
//                autoComplete="given-name"
//               className="rounded-lg w-full
//               bg-white border-2 border-gray-300 placeholder-gray-400  focus:placeholder-gray-200 focus:bg-white focus:border-indigo-300  focus:outline-none" 
//               value={description}
//               onChange={(e)=>setDescription(e.target.value)}  
//                 >

//               <option value="">
//                       Select an option
//                   </option>
                 
//                   <option value="Fuel">
//                   Fuel
//                   </option>
//                   <option value="Bhutanese Payment">
//                   Bhutanese Payment
//                   </option>
//                   <option value="Indian Payment">
//                   Indian Payment
//                   </option>
//                   <option value="Timber Purchase">
//                   Timber Purchase                  
//                   </option>
//                   <option value="Timber Advance">
//                   Timber Advance                  
//                   </option>
//                   <option value="Machine Parts">
//                   Machine Parts                   
//                   </option>
//                   <option value="Mess">
//                   Mess                   
//                   </option>
//                   <option value="Others">
//                   Others                   
//                   </option>

//                 </select>



//               <label htmlFor="first_name" className="block text-sm font-medium text-gray-700">Jrnl</label>

//               <input type="text" 
//               name="first_name"
//                id="first_name" 
//                autoComplete="given-name"
//               className="rounded-lg w-full
//               bg-white border-2 border-gray-300 placeholder-gray-400  focus:placeholder-gray-200 focus:bg-white focus:border-indigo-300  focus:outline-none" 
//               value={jrnl}
//               onChange={(e)=>setJrnl(e.target.value)}  
//                 />
                
            
//                 {/* <input type="text" 
//                 name="first_name"
//                  id="first_name" 
//                  autoComplete="given-name"
//                 className="rounded-lg w-full
//                 bg-white border-2 border-gray-300 placeholder-gray-400  focus:placeholder-gray-200 focus:bg-white focus:border-indigo-300  focus:outline-none" 
//                 value={name}
//                 onChange={(e)=>setName(e.target.value)}  
//                   /> */}
//               </div>
              
         
             
          
//               <div className="col-span-6 sm:col-span-4">
//                 <label htmlFor="email_address" className="block text-sm font-medium text-gray-700">Amount</label>
//                <input type="number"  className="rounded-lg w-full
//                 bg-white border-2 border-gray-300 placeholder-gray-400  focus:placeholder-gray-200 focus:bg-white focus:border-indigo-300  focus:outline-none" 
                
//                 value={amount}
//                 onChange={(e)=>setAmount(e.target.value)} 
//                 ></input>
//               </div>
//               <div className="col-span-6 sm:col-span-4">
//                 <label htmlFor="email_address" className="block text-sm font-medium text-gray-700">Date</label>
//                 <DatePicker className="rounded-lg w-full
//         bg-white border-2 border-gray-300 placeholder-gray-400 focus:placeholder-gray-200 focus:bg-white focus:border-indigo-300  focus:outline-none" selected={date} onChange={date => setDate(date)} />

//               </div>
              

            
          
              
//             </div>
              
       
//           </div>
          
          
//         </div>


//       </form>
//           </div>
          
//           <div className="flex items-center  justify-end p-6 ">
//             <button
//               className="bg-red-500 text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
//               type="button"
//               style={{ transition: "all .15s ease"  }}
//               onClick={() => setAddCredit(false)}
//             >
//               Cancel
//             </button>
//             <button
//               className="bg-blue-400 text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
//               type="button"
//               style={{ transition: "all .15s ease" }}
//               onClick={() => {setAddCredit(false); postCredit() }}
//             >
//               Add Expense 
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
//   </>
// )


// :null

// }
   
//   </div>
// </main>
// </div>

//     </div>
//   </div>  
// );


  
// }



// export default Expense
import React, { useContext, useCallback, useState, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Select from "react-select";
import debounce from 'lodash/debounce';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Image } from '@react-pdf/renderer';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import NavBar from './nav';
import { UserContex } from '../App';

const Expense = () => {
  const history = useHistory();
  const { state, dispatch } = useContext(UserContex);
  
  // State for all expenses (master data)
  const [allExpenses, setAllExpenses] = useState([]);
  const [filteredExpenses, setFilteredExpenses] = useState([]);
  const [TotalExpense, setTotalExpense] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 20
  });

  // Filter states
  const [search, setSearch] = useState("");
  const [addCredit, setAddCredit] = useState(false);
  const [showCalender, setShowCalender] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  
  // Filter values
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);

  // Sort order state (ascending/descending)
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' for oldest first, 'desc' for newest first

  // Form states
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [jrnl, setJrnl] = useState("");
  const [date, setDate] = useState(new Date());

  // Category options
  const categoryOptions = useMemo(() => [
    { value: "", label: "All Categories" },
    { value: "Fuel", label: "Fuel" },
    { value: "Bhutanese Payment", label: "Bhutanese Payment" },
    { value: "Indian Payment", label: "Indian Payment" },
    { value: "Timber Purchase", label: "Timber Purchase" },
    { value: "Timber Advance", label: "Timber Advance" },
    { value: "Machine Parts", label: "Machine Parts" },
    { value: "Mess", label: "Mess" },
    { value: "Others", label: "Others" }
  ], []);

  const monthOptions = useMemo(() => [
    { value: "", label: "All Months" },
    { value: "0", label: "January" },
    { value: "1", label: "February" },
    { value: "2", label: "March" },
    { value: "3", label: "April" },
    { value: "4", label: "May" },
    { value: "5", label: "June" },
    { value: "6", label: "July" },
    { value: "7", label: "August" },
    { value: "8", label: "September" },
    { value: "9", label: "October" },
    { value: "10", label: "November" },
    { value: "11", label: "December" }
  ], []);

  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const years = [{ value: "", label: "All Years" }];
    for (let i = currentYear + 1; i >= 2020; i--) {
      years.push({ value: i.toString(), label: i.toString() });
    }
    return years;
  }, []);

  const monthYearOptions = useMemo(() => {
    const options = [{ value: "", label: "All Periods" }];
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= currentYear - 2; y--) {
      for (let i = 11; i >= 0; i--) {
        options.push({
          value: `${y}-${i}`,
          label: `${monthOptions[i + 1].label} ${y}`
        });
      }
    }
    return options;
  }, [monthOptions]);

  // Sort expenses by date
  const sortExpensesByDate = useCallback((expenses, order = 'asc') => {
    return [...expenses].sort((a, b) => {
      const dateA = a.date ? new Date(a.date) : new Date(0);
      const dateB = b.date ? new Date(b.date) : new Date(0);
      
      if (order === 'asc') {
        // Ascending: older dates first
        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;
        // If dates are equal, sort by creation time (use _id as fallback)
        return (a._id || '').localeCompare(b._id || '');
      } else {
        // Descending: newer dates first
        if (dateA > dateB) return -1;
        if (dateA < dateB) return 1;
        return (b._id || '').localeCompare(a._id || '');
      }
    });
  }, []);

  // Fetch all expenses on mount
  useEffect(() => {
    fetchAllExpenses();
  }, []);

  const fetchAllExpenses = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/getExpenses`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("jwt")
        }
      });
      const result = await response.json();
      console.log("Fetched expenses:", result.expenses);
      
      // Sort expenses by date (ascending by default)
      const sortedExpenses = sortExpensesByDate(result.expenses || [], 'asc');
      
      setAllExpenses(sortedExpenses);
      setFilteredExpenses(sortedExpenses);
      setTotalExpense(result.sumExpense || 0);
      
      const totalItems = sortedExpenses?.length || 0;
      setPagination(prev => ({
        ...prev,
        totalItems,
        totalPages: Math.ceil(totalItems / prev.itemsPerPage)
      }));
    } catch (error) {
      console.error("Error fetching expenses:", error);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get current filtered data
  const getCurrentFilteredData = useCallback(() => {
    let filtered = [...allExpenses];

    if (search && search.trim()) {
      const searchTerm = search.toLowerCase().trim();
      filtered = filtered.filter(expense => 
        (expense.name && expense.name.toLowerCase().includes(searchTerm)) ||
        (expense.description && expense.description.toLowerCase().includes(searchTerm)) ||
        (expense.jrnl && expense.jrnl.toLowerCase().includes(searchTerm))
      );
    }

    if (selectedCategory && selectedCategory.value && selectedCategory.value !== "") {
      filtered = filtered.filter(expense => expense.description === selectedCategory.value);
    }

    if (selectedMonthYear && selectedMonthYear.value && selectedMonthYear.value !== "") {
      const [year, month] = selectedMonthYear.value.split('-');
      const targetYear = parseInt(year);
      const targetMonth = parseInt(month);
      filtered = filtered.filter(expense => {
        if (!expense.date) return false;
        const expenseDate = new Date(expense.date);
        return expenseDate.getFullYear() === targetYear && expenseDate.getMonth() === targetMonth;
      });
    } else {
      if (selectedYear && selectedYear.value && selectedYear.value !== "") {
        const targetYear = parseInt(selectedYear.value);
        filtered = filtered.filter(expense => {
          if (!expense.date) return false;
          const expenseDate = new Date(expense.date);
          return expenseDate.getFullYear() === targetYear;
        });
      }
      
      if (selectedMonth && selectedMonth.value && selectedMonth.value !== "") {
        const targetMonth = parseInt(selectedMonth.value);
        filtered = filtered.filter(expense => {
          if (!expense.date) return false;
          const expenseDate = new Date(expense.date);
          return expenseDate.getMonth() === targetMonth;
        });
      }
    }

    // Apply sorting
    filtered = sortExpensesByDate(filtered, sortOrder);
    
    return filtered;
  }, [allExpenses, search, selectedCategory, selectedMonth, selectedYear, selectedMonthYear, sortOrder, sortExpensesByDate]);

  // Apply all filters to the expenses
  const applyFilters = useCallback(() => {
    const filtered = getCurrentFilteredData();
    
    const total = filtered.reduce((sum, expense) => sum + (expense.amount || 0), 0);
    setTotalExpense(total);
    
    const totalItems = filtered.length;
    const totalPages = Math.ceil(totalItems / pagination.itemsPerPage);
    setPagination(prev => ({
      ...prev,
      totalItems,
      totalPages,
      currentPage: 1
    }));
    
    const startIndex = 0;
    const endIndex = pagination.itemsPerPage;
    setFilteredExpenses(filtered.slice(startIndex, endIndex));
    
  }, [getCurrentFilteredData, pagination.itemsPerPage]);

  // Apply filters whenever any filter changes
  useEffect(() => {
    if (allExpenses.length > 0) {
      applyFilters();
    }
  }, [applyFilters, allExpenses.length]);

  // Handle pagination
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      const filtered = getCurrentFilteredData();
      const startIndex = (newPage - 1) * pagination.itemsPerPage;
      const endIndex = startIndex + pagination.itemsPerPage;
      setFilteredExpenses(filtered.slice(startIndex, endIndex));
      setPagination(prev => ({ ...prev, currentPage: newPage }));
    }
  };

  // Toggle sort order
  const toggleSortOrder = () => {
    setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
  };

  // Debounced search
  const debouncedSearch = useMemo(
    () => debounce((value) => {
      setSearch(value);
    }, 300),
    []
  );

  const handleSearchChange = (e) => {
    debouncedSearch(e.target.value);
  };

  // Reset all filters
  const resetFilters = () => {
    setSelectedCategory(null);
    setSelectedMonth(null);
    setSelectedYear(null);
    setSelectedMonthYear(null);
    setSearch("");
    setSortOrder('asc'); // Reset sort order to ascending
  };

  // Excel Export Function
  const exportToExcel = useCallback(() => {
    const filteredData = getCurrentFilteredData();
    
    if (filteredData.length === 0) {
      alert("No data to export!");
      return;
    }

    // Prepare data for Excel
    const excelData = filteredData.map(expense => ({
      'Name': expense.name || '',
      'Description': expense.description || '',
      'Journal Reference': expense.jrnl || '',
      'Amount (Nu.)': expense.amount || 0,
      'Date': expense.date ? new Date(expense.date).toLocaleDateString() : '',
      'Category': expense.description || '',
      'Year': expense.date ? new Date(expense.date).getFullYear() : '',
      'Month': expense.date ? new Date(expense.date).toLocaleString('default', { month: 'long' }) : ''
    }));

    // Add summary row
    const summary = {
      'Name': 'TOTAL',
      'Description': '',
      'Journal Reference': '',
      'Amount (Nu.)': TotalExpense,
      'Date': '',
      'Category': '',
      'Year': '',
      'Month': ''
    };
    
    excelData.push(summary);

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    
    // Set column widths
    const columnWidths = [
      { wch: 20 }, // Name
      { wch: 25 }, // Description
      { wch: 15 }, // Journal Reference
      { wch: 15 }, // Amount
      { wch: 15 }, // Date
      { wch: 20 }, // Category
      { wch: 10 }, // Year
      { wch: 12 }  // Month
    ];
    worksheet['!cols'] = columnWidths;

    // Style the total row
    const totalRowIndex = excelData.length;
    const totalCellAddress = `D${totalRowIndex}`;
    if (worksheet[totalCellAddress]) {
      worksheet[totalCellAddress].s = {
        font: { bold: true, color: { rgb: "FF0000" } },
        fill: { fgColor: { rgb: "FFFF00" } }
      };
    }

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Expenses Report');

    // Generate filename with current filters
    let fileName = 'expenses_report';
    if (selectedYear?.value) {
      fileName += `_${selectedYear.value}`;
    }
    if (selectedMonth?.value) {
      fileName += `_${selectedMonth.label}`;
    }
    if (selectedMonthYear?.value) {
      fileName += `_${selectedMonthYear.label.replace(/\s/g, '_')}`;
    }
    if (selectedCategory?.value) {
      fileName += `_${selectedCategory.value.replace(/\s/g, '_')}`;
    }
    fileName += `_${new Date().toISOString().split('T')[0]}.xlsx`;

    // Export
    XLSX.writeFile(workbook, fileName);
  }, [getCurrentFilteredData, TotalExpense, selectedYear, selectedMonth, selectedMonthYear, selectedCategory]);

  // Add expense
  const postCredit = useCallback(async () => {
    if (!name || !description || !amount) {
      alert("Please fill all required fields");
      return;
    }

    try {
      const response = await fetch('/addExpenses', {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("jwt")
        },
        body: JSON.stringify({
          name,
          description,
          jrnl,
          amount: parseFloat(amount),
          date
        })
      });

      const data = await response.json();
      
      if (data.error) {
        console.log("Error:", data.error);
        alert("Error adding expense");
      } else {
        setAddCredit(false);
        fetchAllExpenses();
        setName("");
        setDescription("");
        setAmount("");
        setJrnl("");
        setDate(new Date());
      }
    } catch (error) {
      console.error("Error posting expense:", error);
      alert("Error adding expense");
    }
  }, [name, description, amount, jrnl, date]);

  // Delete expense
  const deleteExpense = useCallback(async (id) => {
    if (!window.confirm('Are you sure you want to delete?')) return;

    try {
      const response = await fetch(`/deleteexpense/${id}`, {
        method: "delete",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("jwt")
        }
      });

      if (response.ok) {
        fetchAllExpenses();
      }
    } catch (error) {
      console.error("Error deleting expense:", error);
    }
  }, []);

  // Search by date from calendar
  const searchByDate = useCallback(async (dateStr) => {
    setSelectedMonthYear(null);
    setSelectedMonth(null);
    setSelectedYear(null);
    
    const filtered = allExpenses.filter(expense => {
      if (!expense.date) return false;
      const expenseDate = new Date(expense.date).toISOString().split('T')[0];
      return expenseDate === dateStr;
    });
    
    const sortedFiltered = sortExpensesByDate(filtered, sortOrder);
    const total = sortedFiltered.reduce((sum, expense) => sum + (expense.amount || 0), 0);
    setTotalExpense(total);
    setFilteredExpenses(sortedFiltered);
    setPagination(prev => ({
      ...prev,
      totalItems: sortedFiltered.length,
      totalPages: Math.ceil(sortedFiltered.length / prev.itemsPerPage),
      currentPage: 1
    }));
  }, [allExpenses, sortOrder, sortExpensesByDate]);

  // PDF Component
  const PDFComponent = useMemo(() => (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image style={styles.logo} src="/logo.png" />
          <Text style={styles.address}>Green Gold Wood Works</Text>
          <Text style={{ fontSize: 10, marginBottom: 3 }}>Tsirang</Text>
          <Text style={{ fontSize: 10, marginBottom: 3 }}>TPN: GAB66324</Text>
          <Text style={{ fontSize: 10, marginBottom: 3 }}>Contact:77428435 / 77413093</Text>
        </View>

        <View style={styles.invoiceDetails}>
          <View style={styles.itemList}>
            <View style={styles.itemRow}>
              <Text style={styles.label}>Name</Text>
              <Text style={styles.label}>Description</Text>
              <Text style={styles.label}>Amount</Text>
              <Text style={styles.label}>Date</Text>
            </View>
            {filteredExpenses.map((item, index) => (
              <View key={index} style={styles.itemRow}>
                <Text style={styles.itemDescription}>{item.name}</Text>
                <Text style={styles.itemDescription}>{item.description}</Text>
                <Text style={styles.itemDescription}>{item.amount}</Text>
                <Text style={styles.itemDescription}>{item.date?.substring(0, 10)}</Text>
              </View>
            ))}
          </View>

          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Total: Nu. {TotalExpense.toLocaleString()}</Text>
          </View>
        </View>
      </Page>
    </Document>
  ), [filteredExpenses, TotalExpense]);

  return (
    <div className="flex h-screen bg-white">
      <link rel="stylesheet" href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css" />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <NavBar />

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-white">
          <div className="container mx-auto px-6 py-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-gray-400 text-3xl font-medium">Expenses</h3>
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="flex items-center px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
                {showFilters ? "Hide Filters" : "Show Filters"}
              </button>
            </div>

            {/* Loading Indicator */}
            {loading && (
              <div className="fixed top-4 right-4 z-50">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              </div>
            )}

            {/* Filters Section */}
            {showFilters && (
              <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                    <Select
                      options={categoryOptions}
                      value={selectedCategory}
                      onChange={setSelectedCategory}
                      placeholder="Select Category"
                      isClearable
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Month</label>
                    <Select
                      options={monthOptions}
                      value={selectedMonth}
                      onChange={(option) => {
                        setSelectedMonth(option);
                        if (option?.value) setSelectedMonthYear(null);
                      }}
                      placeholder="Select Month"
                      isClearable
                      isDisabled={!!selectedMonthYear}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Year</label>
                    <Select
                      options={yearOptions}
                      value={selectedYear}
                      onChange={(option) => {
                        setSelectedYear(option);
                        if (option?.value) setSelectedMonthYear(null);
                      }}
                      placeholder="Select Year"
                      isClearable
                      isDisabled={!!selectedMonthYear}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Month & Year</label>
                    <Select
                      options={monthYearOptions}
                      value={selectedMonthYear}
                      onChange={(option) => {
                        setSelectedMonthYear(option);
                        if (option?.value) {
                          setSelectedMonth(null);
                          setSelectedYear(null);
                        }
                      }}
                      placeholder="Select Period"
                      isClearable
                    />
                  </div>
                </div>

                <div className="flex justify-between items-center mt-4">
                  <div className="text-sm text-gray-500">
                    {pagination.totalItems} expense(s) found
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={resetFilters}
                      className="px-4 py-2 text-sm bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                    >
                      Reset All Filters
                    </button>
                    <button
                      onClick={exportToExcel}
                      className="px-4 py-2 text-sm bg-green-500 text-white rounded-lg hover:bg-green-600 transition flex items-center gap-2"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                      </svg>
                      Export to Excel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Stats Card */}
            <div className="shadow-lg rounded-xl bg-white w-full md:w-80 p-6 mb-6 border border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="rounded-lg p-3 bg-blue-50">
                    <svg className="h-8 w-8 text-blue-500" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none">
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <rect x="7" y="9" width="14" height="10" rx="2" />
                      <circle cx="14" cy="14" r="2" />
                      <path d="M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2" />
                    </svg>
                  </span>
                  <div className="ml-3">
                    <p className="text-2xl font-bold text-gray-800">Nu. {TotalExpense.toLocaleString()}</p>
                    <p className="text-sm text-gray-500">Total Expenses</p>
                  </div>
                </div>
                <button
                  type="button"
                  className="px-4 py-2 bg-black hover:bg-gray-800 text-white rounded-lg transition duration-200 text-sm font-semibold"
                  onClick={() => setAddCredit(true)}
                >
                  + Add Expense
                </button>
              </div>
            </div>

            {/* Search Bar and Sort Toggle */}
            <div className="flex gap-2 mb-4">
              <div className="relative flex-1">
                <input
                  type="text"
                  placeholder="Search by name, description, or journal..."
                  className="w-full px-4 py-2 pl-10 pr-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  onChange={handleSearchChange}
                  defaultValue={search}
                />
                <svg className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              
              {/* Sort Order Toggle Button */}
              <button
                onClick={toggleSortOrder}
                className="px-4 py-2 flex items-center rounded-lg border border-gray-300 hover:bg-gray-50 transition"
                title={sortOrder === 'asc' ? 'Oldest first' : 'Newest first'}
              >
                <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {sortOrder === 'asc' ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
                  )}
                </svg>
                {sortOrder === 'asc' ? 'Oldest First' : 'Newest First'}
              </button>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-row items-center mb-4 space-x-2 flex-wrap gap-2">
              <button
                className={`px-4 py-2 flex items-center rounded-lg transition ${showCalender ? "bg-blue-100 text-blue-700" : "border border-gray-300 hover:bg-gray-50"}`}
                onClick={() => setShowCalender(!showCalender)}
              >
                <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <rect x="4" y="5" width="16" height="16" rx="2" />
                  <line x1="16" y1="3" x2="16" y2="7" />
                  <line x1="8" y1="3" x2="8" y2="7" />
                  <line x1="4" y1="11" x2="20" y2="11" />
                </svg>
                {showCalender ? "Hide Calendar" : "Search by Date"}
              </button>

              <PDFDownloadLink document={PDFComponent} fileName="expenses_report.pdf">
                {({ loading }) => (
                  <button className="px-4 py-2 flex items-center rounded-lg border border-gray-300 hover:bg-gray-50 transition">
                    <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
                      <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
                      <rect x="7" y="13" width="10" height="8" rx="2" />
                    </svg>
                    {loading ? 'Generating...' : 'Print Report'}
                  </button>
                )}
              </PDFDownloadLink>

              <button
                onClick={exportToExcel}
                className="px-4 py-2 flex items-center rounded-lg bg-green-500 text-white hover:bg-green-600 transition"
              >
                <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                </svg>
                Export to Excel
              </button>
            </div>

            {/* Calendar View */}
            {showCalender && (
              <div className="mb-6 bg-white rounded-lg border border-gray-200 p-4">
                <FullCalendar
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth',
                  }}
                  initialView='dayGridMonth'
                  height={400}
                  dateClick={(info) => searchByDate(info.dateStr)}
                />
              </div>
            )}

            {/* Active Filters Display */}
            {(selectedCategory?.value || selectedMonth?.value || selectedYear?.value || selectedMonthYear?.value || search) && (
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="text-sm text-gray-500">Active Filters:</span>
                {search && (
                  <span className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
                    Search: {search}
                  </span>
                )}
                {selectedCategory?.value && (
                  <span className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
                    Category: {selectedCategory.label}
                  </span>
                )}
                {selectedMonth?.value && (
                  <span className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
                    Month: {selectedMonth.label}
                  </span>
                )}
                {selectedYear?.value && (
                  <span className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded-full">
                    Year: {selectedYear.label}
                  </span>
                )}
                {selectedMonthYear?.value && (
                  <span className="px-2 py-1 text-xs bg-purple-100 text-purple-700 rounded-full">
                    Period: {selectedMonthYear.label}
                  </span>
                )}
                <span className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded-full">
                  Sort: {sortOrder === 'asc' ? 'Oldest First' : 'Newest First'}
                </span>
              </div>
            )}

            {/* Expenses Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {filteredExpenses.length > 0 ? (
                filteredExpenses.map(item => (
                  <div key={item._id} className="bg-white p-4 rounded-xl shadow-md border hover:shadow-lg transition relative group">
                    <button
                      className="absolute top-2 right-2 text-red-400 hover:text-red-600 opacity-0 group-hover:opacity-100 transition"
                      onClick={() => deleteExpense(item._id)}
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                    <div className="font-semibold text-gray-800 mb-1 pr-6">{item.name}</div>
                    <div className="text-sm text-gray-500 mb-1">Description: {item.description}</div>
                    {item.jrnl && <div className="text-sm text-gray-500 mb-1">Jrnl: {item.jrnl}</div>}
                    <div className="text-lg font-bold text-blue-600 mt-2">Nu. {item.amount?.toLocaleString()}</div>
                    <div className="text-xs text-gray-400 mt-1">
                      {item.date ? new Date(item.date).toLocaleDateString() : 'No date'}
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-full text-center py-12">
                  <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="mt-2 text-gray-500">No expenses found</p>
                  <p className="text-sm text-gray-400">Try adjusting your filters or add a new expense</p>
                </div>
              )}
            </div>

            {/* Pagination */}
            {pagination.totalPages > 1 && (
              <div className="flex justify-center items-center space-x-2 mt-6">
                <button
                  onClick={() => handlePageChange(pagination.currentPage - 1)}
                  disabled={pagination.currentPage === 1}
                  className="px-3 py-1 rounded border disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                >
                  Previous
                </button>
                <span className="px-4 py-1 text-sm">
                  Page {pagination.currentPage} of {pagination.totalPages}
                </span>
                <button
                  onClick={() => handlePageChange(pagination.currentPage + 1)}
                  disabled={pagination.currentPage === pagination.totalPages}
                  className="px-3 py-1 rounded border disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </main>
      </div>

      {/* Add Expense Modal */}
      {addCredit && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
              <div className="flex justify-between items-center p-4 border-b">
                <h3 className="text-lg font-semibold">Add New Expense</h3>
                <button
                  onClick={() => setAddCredit(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <div className="p-4 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter expense name"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Category *</label>
                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  >
                    <option value="">Select a category</option>
                    {categoryOptions.slice(1).map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Journal Reference</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={jrnl}
                    onChange={(e) => setJrnl(e.target.value)}
                    placeholder="Optional reference number"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Amount (Nu.) *</label>
                  <input
                    type="number"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter amount"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
                  <DatePicker
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    selected={date}
                    onChange={setDate}
                    dateFormat="yyyy-MM-dd"
                  />
                </div>
              </div>
              
              <div className="flex justify-end space-x-3 p-4 border-t">
                <button
                  onClick={() => setAddCredit(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={postCredit}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                >
                  Add Expense
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    padding: 30,
  },
  header: {
    marginBottom: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  address: {
    fontSize: 12,
    marginBottom: 10,
  },
  invoiceDetails: {
    marginBottom: 20,
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  itemList: {
    marginTop: 20,
  },
  itemRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e5e5',
    paddingBottom: 5,
  },
  itemDescription: {
    width: '25%',
    fontSize: 10,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 20,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#000',
  },
  totalLabel: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  logo: {
    width: 60,
    height: 60,
    marginBottom: 10,
  },
});

export default Expense;